import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledPublishModificationId = Brand<number, 'ScheduledPublishModificationId'>;
export const ScheduledPublishModificationId = createBranded<ScheduledPublishModificationId>();
